
import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'perfil-user-component-sidebar',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css'
})
export class SidebarComponent {
  toggleCollapse() {
    const content = document.getElementById('collapse-content');
    content?.classList.toggle('hidden');
  }

  isHidenCollapse(){
    const content = document.getElementById('collapse-content');
    return content?.classList.contains('hidden');
  }
}
